'use strict';

var pages = {
    product: require('./pages/product'),
    cart: require('./pages/cart'),
    search: require('./pages/search'),
    checkout: require('./pages/checkout'),
    account: require('./pages/account'),
    orderconfirmation: require('./pages/confirmation')
}

exports.init = function () {
    try {

        /**
         * the following code helping determine if tealium library is ready for work, (document.ready not helped here)
         * so we can fire events after page load
         */
        var intervalHnadler = null;
        intervalHnadler = setInterval(function () {
          var utag_data = window.utag_data;
          if (utag_data && utag_data.adobeAnalytics === true) {
            window.utag = window.adobeDataLayer;
          }
          if (window.utag !== undefined) {
              var ns = window.pageContext.ns;
              if (ns && pages[ns] && pages[ns].init) {
                  pages[ns].init();
              }
              //global events
              var common = require('./pages/common');
              common.init();
              clearInterval(intervalHnadler);
          }
        }, 100);
    } catch (err) {
        window.console.log('tealium error: ' + err);
    }
}
